import IMask from 'imask'


document.addEventListener("TwinsparkLoaded", () => {
  console.log('TwinsparkLoaded!')
  window.twinspark.func({
    initImask: function(o) {
      console.log('init IMask!')
      new IMask.InputMask(o.el, {
        mask: "+0 (000) 000-00-00",
      })
      o.el.addEventListener("focus", function(e) {
        const el = this
        setTimeout(function() {
          el.selectionStart = el.selectionEnd = 10000
        }, 0)
      })
    },
    callRequest: function(o) {
      grecaptcha.ready(function() {
        grecaptcha.execute(RECAPTCHA_PUBLIC_KEY, { action: 'submit' }).then(function(token) {
          let req = twinspark.makeReq(
            o.el,
            undefined,
            false,
            {
              method: 'post',
              url: '/ts/call-request/create/',
              data: [
                ['captcha', token],
                ['csrfmiddlewaretoken', o.el.querySelector('[name=csrfmiddlewaretoken]').value],
                ['name', o.el.querySelector('[name=name]').value],
                ['phone', o.el.querySelector('[name=phone]').value]
              ]
            }
          );
          twinspark.executeReqs(req);
        });
      });
      return false;
    },
    changeDeliveryMethod: function(o) {
      const el = o.el
      const deliveryMethodBtn = el.parentNode.querySelectorAll(".component_delivery-method")
      deliveryMethodBtn.forEach(i => i.classList.remove("_active"))
      el.classList.add("_active")
      document.getElementById("delivery_type").value = el.getAttribute("value")
    },
  })
})
